import { getUserLocation } from "./location";

/**
 * Checks if a user should be redirected to a different domain based on
 * their location and language preferences.
 *
 * - If user is in Quebec and using French, they should be on nettoigo.ca
 * - If user is outside Quebec, they should be on nettoigo.ca
 *
 * @returns {boolean} True if redirect was performed, false otherwise
 */
export function checkDomainRedirect(): boolean {
  // Skip in development environment
  if (process.env.NODE_ENV !== "production") {
    console.log("Skipping domain redirect in development environment");
    return false;
  }

  // Get current hostname
  let hostname = window.location.hostname;
  if (hostname === "localhost") {
    hostname = "nettoigo.ca";
  }

  // If not on either production domain, don't redirect
  if (hostname !== "nettoigo.ca") {
    console.log("Not on either production domain, skipping redirect");
    console.log("Hostname:", hostname);
    return false;
  }

  // Get preferred language from localStorage
  const preferredLang =
    localStorage.getItem("i18nextLng") || navigator.language.split("-")[0];

  // Try to determine if user is in Quebec
  const userLocation = getUserLocation();
  console.log("User location:", userLocation);
  const userInQuebec =
    userLocation?.province === "Quebec" || userLocation?.province === "Québec";

  // Determine if redirect is needed
  let shouldRedirect = false;
  let targetDomain = "";

  if (userInQuebec && preferredLang === "fr" && hostname === "nettoigo.ca") {
    // Quebec user with French preference on weklean.ca - redirect to nettoigo.ca
    shouldRedirect = true;
    targetDomain = "nettoigo.ca";
  } else if (
    (!userInQuebec || preferredLang !== "fr") &&
    hostname !== "nettoigo.ca"
  ) {
    // Non-Quebec user or non-French user on nettoigo.ca - redirect to weklean.ca
    shouldRedirect = true;
    targetDomain = "nettoigo.ca";
  }

  // Perform redirect if needed
  if (shouldRedirect && targetDomain) {
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    window.location.href = `https://${targetDomain}${currentPath}${currentSearch}`;
    return true;
  }

  return false;
}

/**
 * Gets the site name based on current domain
 * @returns {string} "NettoiGo"
 */
export function getSiteName(): string {
  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "";
  return "NettoiGo"; // TODO: Remove this once we have a proper domain name
  // return hostname === "nettoigo.ca" ? "NettoiGo" : "WeKlean";
}
